<template>
  <div>
    <b-button
      v-permission="'legal_entities.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <!-- O grid vem de /professionals/grid, que impõe person_type=NE no servidor.
         Filtrar no cliente quebraria a paginação — a página 2 voltaria com
         estabelecimentos — e dependeria de um filtro que a requisição pode trocar. -->
    <Grid :css_formats="gridCssFormats()"
          :service="service"
          route_name="professionals">
      <template #gridThead="thead">
        <!-- A coluna do documento é a mesma do estabelecimento (o CPF mora onde
             morava o CNPJ), mas o rótulo não pode ser: aqui é sempre CPF. -->
        <vs-th
          v-for="(column, key) in thead.data"
          :key="key"
          :sort-key="thead.methods.getColumnSortKey(key)"
          sort-status="asc">{{ columnLabel(thead.methods.getOriginalColumnName(column)) }}</vs-th>
        <vs-th>Habilitação</vs-th>
      </template>
      <template #gridData="gridData">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in gridData.data">
          <vs-td
            :data="gridData.data[indextr].id"
            v-for="(column, key) in gridData.columns"
            :key="key">
            <div :class="gridData.methods.getColumnCss(gridData.data[indextr], key)">
              <div :key="key" v-html-safe="`<div>${gridData.methods.getColumnData(gridData.data[indextr],key)}</div>`"/>
            </div>
          </vs-td>
          <vs-td>
            <b-badge :variant="kycVariant(gridData.data[indextr].kyc_status)">
              {{ kycLabel(gridData.data[indextr].kyc_status) }}
            </b-badge>
          </vs-td>
          <vs-td>
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="`legal_entities.edit`"
                icon="EditIcon"
                class="h-5 w-5 stroke-current text-warning"
                @click="gridData.edit(gridData.data[indextr].id)"/>
              <feather-icon
                v-permission="`legal_entities.delete`"
                icon="Trash2Icon"
                class="h-5 w-5 stroke-current text-danger"
                @click="gridData.destroy(gridData.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton, BBadge } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ProfessionalService from '@/services/api/ProfessionalService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BBadge,
  },
  data: () => ({
    service: null,
    kycLabels: {
      PE: 'Pendente',
      AP: 'Aprovado',
      RJ: 'Recusado',
    },
  }),
  methods: {
    gridCssFormats() {
      return {
        company_name: () => 'flex flex-row'
      }
    },
    columnLabel(originalColumnName) {
      const overrides = {
        cnpj: 'CPF',
        company_name: 'Nome',
        trading_name: 'Nome público',
      }

      return overrides[originalColumnName] || this.$t(`establishment.${originalColumnName}`)
    },
    kycLabel(status) {
      return this.kycLabels[status] || 'Pendente'
    },
    kycVariant(status) {
      if (status === 'AP') return 'light-success'
      if (status === 'RJ') return 'light-danger'
      return 'light-warning'
    },
    addNew() {
      this.$router.push('/professionals/create')
    },
  },
  beforeMount() {
    this.service = ProfessionalService.build(this.$vs)
  },
}
</script>
